import api from './api'

/**
 * Get submission statistics for admins
 * @param {Object} options - Query options
 * @param {string} options.formId - Optional form ID to filter stats
 * @returns {Promise<Object>} - Submission stats including counts and outstanding work
 */
export async function getSubmissionStats({ formId } = {}) {
  const params = new URLSearchParams()
  if (formId) params.append('formId', formId)

  const queryString = params.toString()
  const response = await api.get(`/admin/submission-stats${queryString ? '?' + queryString : ''}`)
  return response.data
}
